import { QueryClient, QueryClientProvider as InnerProvider } from 'react-query';

export const queryClient = new QueryClient();

export const QueryClientProvider = ({ children }) => (
  <InnerProvider client={queryClient}>{children}</InnerProvider>
);
